var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 7.292 13 4.058l7.625 3.234c.246.104.38.325.375.533-.017 3.808-1.6 10.387-7.763 13.337a.548.548 0 0 1-.47 0C6.6 18.208 5.02 11.633 5 7.821c0-.209.13-.425.375-.534v.005zm16.03-1.842-7.847-3.33a1.345 1.345 0 0 0-1.116 0L4.596 5.45c-.917.387-1.6 1.292-1.596 2.383.02 4.134 1.72 11.696 8.9 15.134a2.545 2.545 0 0 0 2.2 0c7.183-3.438 8.88-11 8.9-15.134.004-1.091-.68-1.996-1.596-2.383zm-3.697 5.258a1 1 0 0 0-1.412-1.412L11.67 13.92l-1.958-1.959A1 1 0 0 0 8.3 13.374l2.666 2.668a.996.996 0 0 0 1.412 0l5.33-5.334z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.43f139ed.svg";
export { ForwardRef as ReactComponent };